// @ts-check
/* eslint-env browser */

class FullScreen extends HTMLElement {
  connectedCallback () {
    const checkbox = this.querySelector('input[type="checkbox"]')
    const mapContainer = this.closest('map-container')

    if (!checkbox || !mapContainer) return

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        mapContainer.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    })

    document.addEventListener('fullscreenchange', () => {
      checkbox.checked = !!document.fullscreenElement
    })
  }
}

customElements.define('full-screen', FullScreen)
